// extracted by mini-css-extract-plugin
module.exports = {"publicationsContainer":"_33MED","title":"_345d9","tilesList":"_2ewp_","ctaPublications":"_2IqTG","label":"_1EQAG"};